/**
 * Priority value type for task prioritization.
 */
export type PriorityValue = 'High' | 'Medium' | 'Low' | null;

/**
 * Individual priority option configuration.
 */
export interface PriorityOption {
  /** The priority value */
  value: PriorityValue;
  /** Translation key for the label */
  labelKey: string;
  /** CSS class modifier for styling */
  modifier: string;
}

/**
 * Default priority options with their configurations.
 */
export const PRIORITY_OPTIONS: PriorityOption[] = [
  { value: null, labelKey: 'priority-dropdown.not-set', modifier: '' },
  { value: 'Low', labelKey: 'priority-dropdown.low', modifier: 'low' },
  { value: 'Medium', labelKey: 'priority-dropdown.medium', modifier: 'medium' },
  { value: 'High', labelKey: 'priority-dropdown.high', modifier: 'high' },
];
